module.exports = __webpack_public_path__ + "img/D6.04ab766e.svg";